import { Component, OnInit, Renderer2 } from "@angular/core";
import { UserService } from "../../../services/userService";
import { AmazonService } from "../../../services/amazon.service";
import { ActivatedRoute, Router } from "@angular/router";
import { Seller } from "../../../objects/amazon/seller";

@Component({
    selector: 'amazon-seller-form',
    templateUrl: 'amazon-seller-form.component.html',
    moduleId: module.id.toString(),
})

export class AmazonSellerFormComponent {

    constructor (private route: ActivatedRoute, public userService: UserService, public amazonService: AmazonService, private renderer: Renderer2, private router: Router){}

    public ngOnInit(){
    }


    public createSeller(valid: boolean): void{
        if(!valid){
            return;
        }

        this.amazonService.setCurrentSeller(this.amazonService.seller);
        this.router.navigate(["amazon/info/store"]);
    }

}


// WEBPACK FOOTER //
// ./app/components/amazon/seller-form/amazon-seller-form.component.ts